import { Routes } from '@angular/router';
import { AuthGuard } from '../../authguard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'core-list',
    loadComponent: () => import('./components/dealer/core-list/core-list.component').then(m => m.CoreListComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
    pathMatch: 'full',
  },
  {
    path: 'core-def-check/:prolife_sr_no',
    loadComponent: () => import('./components/dealer/core-def-checklist/core-def-checklist.component').then(m => m.CoreDefChecklistComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'l1-core-list',
    loadComponent: () => import('./components/l1-flow/l1-core-list/l1-core-list.component').then(m => m.L1CoreListComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'l1-image-approval/:prolife_sr_no',
    loadComponent: () => import('./components/l1-flow/l1-image-approval/l1-image-approval.component').then(m => m.L1ImageApprovalComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'distributor-list',
    loadComponent: () =>
      import('./components/distributor/distributor-listing/distributor-listing.component').then(m => m.DistributorListingComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'technician-list',
    loadComponent: () => import('./components/technician/technician-listing/technician-listing.component').then(m => m.TechnicianListingComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'plant-core-list',
    loadComponent: () => import('./components/plant/plant-core-list/plant-core-list.component').then(m => m.PlantCoreListComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'tml-listing/:index',
    loadComponent: () => import('./components/plant/tml-listing/tml-listing.component').then(m => m.TmlListingComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'technician-cdc/:prolife_serial_number',
    loadComponent: () => import('./components/technician/technician-cdc/technician-cdc.component').then(m => m.TechnicianCdcComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'pdf-summary',
    loadComponent: () => import('./shared/pdf-summary/pdf-summary.component').then(m => m.PdfSummaryComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    loadComponent: () => import('./shared/notification-page/notification-page.component').then(m => m.NotificationPageComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
];
